module.exports = __webpack_public_path__ + "static/media/google-play.8ac19ee1.png";